import React, { useState, useEffect } from 'react';
import { useLang } from '../../../../hooks/useLang';    
import './standart-form.css';

export function StandartForm() {

    const {currentLanguage} = useLang();
    const [PP, setPP] = useState(false)

    const [getInTouchText, setGetInTouchText] = useState([
        'Let`s talk',
        'All fields are required unless marked optional',
        'Name',
        'Phone number (optional):',
        'Organization name (optional):',
        'Buisness name',
        'Type your message here...',
        'I have read and accepted the <Link to="/terms-of-use">Terms of Use</Link> and <Link to="/privacy-policy">Privacy Policy</Link>*',
        'Submit']);

    useEffect(() => {
        if(currentLanguage === 'EN'){
            setGetInTouchText([
                'Let`s talk',
                'All fields are required unless marked optional',
                'Name',
                'Phone number (optional):',
                'Organization name (optional):',
                'Buisness name',
                'Type your message here...',
                'I have read and accepted the <a href="/terms-of-use">Terms of Use</a> and <a href="/privacy-policy">Privacy Policy</a>*',
                'Submit'
            ]);
        }else if(currentLanguage === 'UK'){
            setGetInTouchText([
                'Звернутись до нас',
                'Усі поля обов’язкові, якщо не позначено як необов’язкові',
                'Ім`я',
                'Номер телефону (не обов`язково):',
                'Назва організації (не обов`язково):',
                'Назва організації',
                'Напишіть ваше повідомлення тут...',
                'Я прочитав і приймаю <a href="/#/terms-of-use">Умови використання</a> і <a href="/#/privacy-policy">Політику конфіденційності</a>*',
                'Надіслати'
            ]);
        }
    }, [currentLanguage]);

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone : '',
        organizationName : '',
        comment: '',
        cv: null,
        termsAccepted: false,
    });
    
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const inputValue = type === 'checkbox' ? checked : value;

        setFormData((prevData) => ({
        ...prevData,
        [name]: inputValue,
        }));
    };

    const FORM_API_URL = "https://tenetixacademy.pythonanywhere.com/tenetix_requests/get_user_data";

    function sendFormData(event) {   
        let form = document.querySelector('.standart_form');
        event.preventDefault();    
        const formData = new FormData(form);
        console.log(formData)
        fetch(FORM_API_URL, {
            method: 'POST',
            mode: 'no-cors',
            body: formData
        })
        .then((response) => {
            if (!response.ok) {
                alert(`HTTP error! Status: ${response.status}`);
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            else{alert("Повідомлення успішно надіслано!")};
        })
    }
    
    return(
        <>
            <form className='standart_form' onSubmit={(e) => sendFormData(e)} >
                <h2>{getInTouchText[0]}</h2>
                <p>{getInTouchText[1]}</p>
                <label>
                {getInTouchText[2]}
                    <input type="text" name="name" value={formData.name} onChange={handleChange} required />
                </label>
                <label>
                    Email
                    <input type="email" name="email" value={formData.email} onChange={handleChange} required />
                </label>


                <label htmlFor='phoneNumber'>{getInTouchText[3]}
                    <input type='tel'
                           name="phone"
                           onChange={handleChange}
                           value={formData.phone}
                           placeholder='+380631234567'
                           maxLength='13' />
                </label>
                <label htmlFor='organizationName'>{getInTouchText[4]}
                    <input type='text'
                           name='organizationName'
                           onChange={handleChange}
                           value={formData.organizationName}
                           placeholder={getInTouchText[5]}/>
                </label>
                <label>
                    <textarea name="message" value={formData.comment} onChange={handleChange} placeholder={getInTouchText[6]} required></textarea>
                </label>
                <div className='standart_form_button-container'>
                    <div className='standart__checkbox-container'>
                        <input
                            type="checkbox"
                            name="termsAccepted"
                            checked={formData.termsAccepted}
                            onChange={handleChange}
                            required
                            className='standart__checkbox-item'
                            onClick={() => setPP(!PP)}
                        />
                        <label dangerouslySetInnerHTML={{__html: getInTouchText[7]}}></label>
                        <button type="submit">{getInTouchText[8]}</button>
                    </div>
                </div>
            </form>
        </>
    );

}